import {Component, inject} from '@angular/core';
import {AuthService} from './auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone: true
})
export class AuthComponent {

  readonly authService: AuthService = inject(AuthService);

  public authorize(): void {
    this.authService.login();
  }

}
